/**
 * Extracts order ID from URL search parameters or hash
 *
 * @param searchParams - URLSearchParams from window.location.search or Next.js searchParams
 * @param hash - Optional hash string from window.location.hash
 * @returns The order ID or null if not found
 */
export function getOrderIdFromUrl(searchParams: URLSearchParams, hash?: string): string | null {
  // Try to get order from query params first
  let order = searchParams.get('order');

  // If not in query params, try hash params
  if (!order && hash) {
    const hashParams = new URLSearchParams(hash.replace(/^#/, ''));

    order = hashParams.get('order');
  }

  return order;
}
